var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "item-icon",
    focusable: "false",
    "aria-labelledby": titleId,
    role: "img",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0021B",
    d: "M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.5,
    d: "M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.133 16.998c0 .354-.054.66-.162.918a1.745 1.745 0 01-1.044 1.012 2.057 2.057 0 01-.693.122h-.621v2.322H9.2V15h1.98c.228 0 .457.033.688.099a1.655 1.655 0 011.089.945c.118.258.176.576.176.954zm-1.35.027c0-.288-.069-.495-.207-.621a.72.72 0 00-.504-.189h-.459v1.665h.459a.665.665 0 00.504-.22c.138-.148.207-.359.207-.635zm6.854 1.179c0 .48-.052.915-.157 1.305-.106.39-.266.723-.482.999a2.14 2.14 0 01-.824.639c-.333.15-.727.225-1.183.225H14.2V15h1.791c.456 0 .85.075 1.183.225.334.15.608.364.824.643.216.28.376.615.482 1.008.105.394.157.836.157 1.328zm-1.449 0c0-.642-.11-1.126-.328-1.454-.22-.327-.503-.49-.851-.49h-.351v3.852h.351c.348 0 .631-.163.85-.49.22-.328.329-.8.329-1.418zm3.961-1.899v1.296h1.521v1.233h-1.512v2.538H19.7V15h3.105v1.305h-1.656z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.c076079e7c4e8e097ddd83c5d5e4efe5.svg";
export { ForwardRef as ReactComponent };